<template>
  <div id="app">
    <div v-if="isShow" style="overflow-y: hidden">
      <nav>
        <div class="logo">
          <img src="../static/favicon.png" />
        </div>
        <ul class="list1">
          <!--<router-link to="/enterpriseManagementRouter">213</router-link>-->
          <li v-for="(item,index) in navListAccept" :key="index">
            <router-link :to="item.route">
              <!--router-link最终渲染为a标签-->
              <!--<router-link tag="button" replace>渲染为button标签,replace返回键失效，history.pushState可返回-->
              <!--<router-link :to="'/pages/user/'+userId">-->
              <strong @click="accordion(index,item)">
                <i :class="item.icon"></i>
                <span>{{item.navItem}}</span>
                <em
                  :class="!item.show ? arrowheadOne : ((item.childNav && item.show)? arrowheadTwo : arrowheadOne)"
                ></em>
              </strong>
            </router-link>
            <ul v-if="item.show">
              <li v-for="(childItem,ind) in item.childNav" :key="ind">
                <router-link :to="childItem.subsetRoute">
                  <span>{{childItem.subset}}</span>
                  <em class="el-icon-arrow-right"></em>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <aside>
        <header>
          <el-dropdown>
            <span class="el-dropdown-link">
              <!--<el-avatar icon="el-icon-user-solid" size="medium" src=""></el-avatar>-->
              <b>{{name}}</b>
              <cite class="el-icon-switch-button el-icon--right"></cite>
            </span>
            <el-dropdown-menu slot="dropdown">
              <p class="quit" @click="logOut">退出登录</p>
            </el-dropdown-menu>
          </el-dropdown>
        </header>
        <router-view class="main"></router-view>
      </aside>
    </div>
    <router-view v-if="!isShow"></router-view>
  </div>
</template>
<script>
import { tLogin } from "@/api/index";
export default {
  name: "App",
  data() {
    return {
      navList: [
        {
          route: "/pages/index",
          navItem: "首页",
          icon: "el-icon-s-home"
        },
        {
          route: "/enterpriseManagementRouter/enterpriseManagement",
          navItem: "用户管理",
          icon: "el-icon-s-help",
          childNav:[
            {
              subset: "用户管理",
              subsetRoute: "/enterpriseManagementRouter/enterpriseManagement"
            },{
              subset: "提现管理",
              subsetRoute: "/enterpriseManagementRouter/userWithdrawal"
            }
          ],
          show: false
        },
        {
          route: "/mealsManagementRouter/classificationManagement",
          navItem: "商品库管理",
          icon: "el-icon-s-management",
          childNav: [
            {
              subset: "商品分类",
              subsetRoute: "/mealsManagementRouter/classificationManagement"
            },
            {
              subset: "商品库",
              subsetRoute: "/mealsManagementRouter/goodsManagement"
            },
          ],
          show: false
        },
        {
          route: "/powerManagementRouter",
          navItem: "认证管理",
          icon: "el-icon-lock",
          childNav: [
            {
              subset: "单店铺认证",
              subsetRoute: "/powerManagementRouter/powerShop"
            },
            {
              subset: "平台认证",
              subsetRoute: "/powerManagementRouter/powerPlatform"
            },
             {
              subset: "外卖认证",
              subsetRoute: "/powerManagementRouter/powerOutGood"
            },
          ],
          show: false
        },
        {
          route: "/mealsManagementRouter",
          navItem: "套餐管理",
          icon: "el-icon-s-management",
          childNav: [
            {
              subset: "套餐列表",
              subsetRoute: "/mealsManagementRouter/mealsList"
            },
            {
              subset: "套餐订单",
              subsetRoute: "/mealsManagementRouter/mealsOrder"
            },
              {
              subset: "增值服务 ",
              subsetRoute: "/mealsManagementRouter/addService"
            },
              {
              subset: "增值订单 ",
              subsetRoute: "/mealsManagementRouter/addServiceOrder"
            },
            {
              subset: "免费升级 ",
              subsetRoute: "/mealsManagementRouter/upServerList"
            },
            {
              subset: "优惠券 ",
              subsetRoute: "/mealsManagementRouter/couponList"
            },
            // {
            //   subset: "商品列表 ",
            //   subsetRoute: "/mealsManagementRouter/goodsManagement"
            // },
            // {
            //   subset: "分类列表 ",
            //   subsetRoute: "/mealsManagementRouter/classificationManagement"
            // },

          ],
          show: false
        },
        {
          route: "/messageManagementRouter",
          navItem: "消息管理",
          icon: "el-icon-s-comment",
          childNav: [
            {
              subset: "公告列表",
              subsetRoute: "/messageManagementRouter/notice"
            },
            {
              subset: "新闻分类",
              subsetRoute: "/messageManagementRouter/newsClassification"
            },
            {
              subset: "新闻列表",
              subsetRoute: "/messageManagementRouter/newList"
            },
            {
              subset: "新闻标签",
              subsetRoute: "/messageManagementRouter/newsLabel"
            },
			{
			  subset: "热搜词汇",
			  subsetRoute: "/messageManagementRouter/hotWords"
			},
            {
              subset: "意见反馈",
              subsetRoute: "/messageManagementRouter/feedBack"
            },
            {
              subset: "投诉建议",
              subsetRoute: "/messageManagementRouter/complaint"
            },


          ],
          show: false
        },
        {
          route: "/administratorsRouter",
          navItem: "管理员",
          icon: "el-icon-user-solid",
          childNav: [
            {
              subset: "管理员",
              subsetRoute: "/administratorsRouter/administrators"
            },
            {
              subset: "操作日志",
              subsetRoute: "/administratorsRouter/operationLog"
            }
          ],
          show: false
        },
        {
          route: "/manageConfigurationRouter",
          navItem: "配置管理",
          icon: "el-icon-s-tools",
          childNav: [
             {
              subset: "基础配置",
              subsetRoute:
                "/manageConfigurationRouter/baseSetting"
            },

            {
              subset: "网站配置",
              subsetRoute:
                "/manageConfigurationRouter/websiteManageConfiguration"
            },
            {
              subset: "订单配置",
              subsetRoute: "/manageConfigurationRouter/orderManageConfiguration"
            },
            {
              subset:"模板配置",
              subsetRoute:"/manageConfigurationRouter/templateConfigure"
            }
              //   {
              //   subset: "域名审核",
              //   subsetRoute:
              //     "/manageConfigurationRouter/damainAudit"
              // },
          ],
          show: false
        },
        { route: "/realmNameRouter/realmName", navItem: "域名配置", icon: "" }
      ],
      navListAccept: [],
      arrowheadOne: "el-icon-arrow-right",
      arrowheadTwo: "el-icon-arrow-down",
      userId: "zero",
      isShow: false,
      name: "",
      nav: "",
      num: 0,
      navChildren: "" //
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == "/log") {
        this.isShow = false;
      } else {
        this.isShow = true;
        if (this.num == 0) {
          console.log(localStorage.getItem("qName"),11111111111);
          if (
            localStorage.getItem("qName") != "" &&
            localStorage.getItem("qName") != null &&
            localStorage.getItem("qName") != undefined
          ) {
            this.name = localStorage.getItem("qName");
          }
          this.nav = localStorage.getItem("navBar");
          if (this.nav != "" && this.nav != null && this.nav != undefined) {

            this.navList.forEach(item => {
              this.nav.split(",").forEach(item1 => {
                if (item.navItem == item1) {
                  this.navListAccept.push(item);
                }
              });
            });
            console.log(this.nav,1212)
          }
        }

        this.num = 2;
      }
    }
  },
  created() {
    localStorage.setItem("navs", JSON.stringify(this.navList));
    console.log(localStorage.getItem("navBar"),1313)
  },
  methods: {
    accordion: function(ind, item) {
      /* this.navList.forEach(i => {
        if (i.show !== this.navList[ind].show){
          i.show = false;
        }
      });*/
      item.show = !item.show;
    },
    async logOut() {
      let result = await tLogin();
      console.log(result);
      if (result.status == 1) {
        this.num = 0;
        this.name = "";
        this.nav = "";
        this.navListAccept = [];
        /*localStorage.removeItem('zero_token');
        localStorage.removeItem('qName');
        localStorage.removeItem('navBar');*/
        localStorage.clear();
        this.$message({
          type: "warning",
          message: result.msg
        });
        this.$router.push({ path: "/log" });
      }
    }
  }
};
</script>

<style scoped>
.list1 ul a {
  display: inline-block;
  width: 100%;
}
.router-link-active {
  text-decoration: none;
}
.router-link-active strong {
  background: #242a3c;
}
.router-link-active i,
.router-link-active span,
.router-link-active em {
  color: #ff501a;
}
nav {
  position: relative;
  top: 0;
  left: 0;
  height: 100vh;
  width: 230px;
  background: #2b3247;
}
header {
  position: fixed;
  top: 0;
  left: 230px;
  height: 60px;
  width: calc(100% - 230px);
  /*background: #006494;*/
  background: #222430;
  z-index: 100000;
}
.el-dropdown {
  float: right;
  margin-right: 50px;
  margin-top: 21px;
}
.el-dropdown b {
  font-weight: normal;
}
.quit {
  margin: 0 10px;
  cursor: pointer;
}
.el-avatar {
  margin-right: 5px;
  vertical-align: -12px;
}
aside {
  position: fixed;
  top: 0;
  left: 230px;
  width: calc(100% - 230px);
}
.logo {
  height: 60px;
  line-height: 80px;
  font-weight: bold;
  text-align: center;
  color: #ff501a;
  background: #222430;
}
.logo img {
  width: 35px;
}
li {
  position: relative;
  cursor: pointer;
}
strong:hover {
  background: #242a3c;
}
strong {
  display: flex;
  align-items: center;
  height: 56px;
  font-weight: normal;
}
.list1 ul li {
  height: 56px;
  line-height: 56px;
}
.list1 ul li:hover {
  background: rgb(0, 80, 118);
}
i {
  position: absolute;
  left: 25px;
}
span {
  margin-left: 47px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
em {
  position: absolute;
  top: 20px;
  right: 40px;
}
i,
span,
em {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue